import React, { useState } from "react";
import { Marker, InfoWindow } from "react-google-maps";
import { Box, Typography } from "@material-ui/core";

// Helpers
import displayName from "../helpers/displayName";

function RiderMarker(props) {
  const { rider } = props;
  const [open, setOpen] = useState(false);

  const toggleInfoWindow = () => {
    setOpen((prevValue) => setOpen(!prevValue));
  };

  return (
    <Marker
      key={rider.id}
      position={{
        lat: rider.riderPosition.latitude,
        lng: rider.riderPosition.longitude,
      }}
      onClick={toggleInfoWindow}
    >
      {open && (
        <InfoWindow onCloseClick={toggleInfoWindow}>
          <Typography component={"span"}>
            <Box display="flex" flexDirection="row">
              <Box fontWeight="fontWeightBold">Rider:</Box>
              <Box pl={1}>
                {displayName(rider.rider.firstName, rider.rider.lastName)}
              </Box>
            </Box>
            {rider.mobileNumber && (
              <Box display="flex" flexDirection="row">
                <Box fontWeight="fontWeightBold">Mobile #:</Box>
                <Box pl={1}>{` ${rider.mobileNumber}`}</Box>
              </Box>
            )}
          </Typography>
        </InfoWindow>
      )}
    </Marker>
  );
}

export default RiderMarker;
